import React from "react";
import { INTAKE_TOUR_NAME_ID } from "../intakeTourSteps";
import classes from "../GuidedIntake.module.less";

/**
 * Editable project-name input. Fully controlled by the parent: the value is the
 * bot's suggested name until the user types, after which the parent stops
 * applying suggestions (see useGuidedIntake).
 */
export const HeaderTitle: React.FC<{
    value: string;
    onChange: (value: string) => void;
    onCommit: () => void;
}> = ({ value, onChange, onCommit }) => (
    <input
        className={classes.headerTitle}
        data-tour-id={INTAKE_TOUR_NAME_ID}
        type="text"
        value={value}
        placeholder="New Project"
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => onCommit()}
        onKeyDown={(e) => {
            if (e.key === "Enter") e.currentTarget.blur();
        }}
        spellCheck={false}
    />
);

export default HeaderTitle;
